import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import LendingAPI from '../api/lendingAPI/LendingAPI.reducer';
import IwIntlProvider from '../iwIntlProvider/IwIntlProvider.reducer';
import OnfidoVerificationModal from '../myAccount/modals/onfidoVerificationModal/OnfidoVerificationModal.reducer';
import PersonModal from '../myAccount/modals/personModal/PersonModal.reducer';
import IwSiteContext from '../iwSiteContext/IwSiteContext.reducer';
import IwRouter from '../iwRouter/IwRouter.reducer';
import Dashboard from '../myAccount/dashboard/Dashboard.reducer';
import AccountHistory from '../myAccount/accountHistory/AccountHistory.reducer';
import TradingData from '../myAccount/tradingData/TradingData.reducer';
import DrawDown from '../myAccount/drawDown/DrawDown.reducer';
import EarlyRepayment from '../myAccount/earlyRepayment/EarlyRepayment.reducer';
import Profile from '../myAccount/Profile/Profile.reducer';
import MainContent from '../myAccount/pageStructure/mainContent/MainContent.reducer';
import Modals from '../iwModals/Modals.reducer';
import EditPaymentMethodModal from '../myAccount/modals/editPaymentMethodModal/EditPaymentMethodModal.reducer';
import AddPaymentMethodModal from '../myAccount/modals/addPaymentMethodModal/AddPaymentMethodModal.reducer';
import RepaymentScheduleModal from '../myAccount/modals/repaymentScheduleModal/RepaymentScheduleModal.reducer';
import ManualPaymentModal from '../myAccount/modals/manualPaymentModal/ManualPaymentModal.reducer';
import ProcessingPaymentModal from '../myAccount/modals/processingPaymentModal/ProcessingPaymentModal.reducer';
import UploadDocumentsModal from '../myAccount/modals/uploadDocumentsModal/UploadDocumentsModal.reducer';
import LinkOpenBankingModal from '../myAccount/modals/linkOpenBankingModal/LinkOpenBankingModal.reducer';
import IwocapayDashboard from '../myAccount/iwocaPay/dashboard/Dashboard.reducer';
import CBILSDashboard from '../myAccount/CBILS/dashboard/Dashboard.reducer';
import MultiLoanDashboard from '../myAccount/multiLoanDashboard/Dashboard.reducer';
import Navigation from '../myAccount/navigation/Navigation.reducer';
import ApplyFlexiLoanView from '../myAccount/applyFlexiLoanView/ApplyFlexiLoanView.reducer';
import RLSDashboard from '../myAccount/RLS/dashboard/Dashboard.reducer';
import RevenueBasedLoan from '../myAccount/revenueBasedLoan/dashboard/Dashboard.reducer';
import LoanBuilderReducer from '../myAccount/myOffers/approvedView/loanBuilder/LoanBuilder.reducer';

const RootReducer = combineReducers({
    siteContext: IwSiteContext,
    intl: IwIntlProvider,
    history: IwRouter,
    dashboard: Dashboard,
    accountHistory: AccountHistory,
    tradingData: TradingData,
    profile: Profile,
    drawDown: DrawDown,
    earlyRepayment: EarlyRepayment,
    mainContent: MainContent,
    modals: Modals,
    repaymentScheduleModal: RepaymentScheduleModal,
    addPaymentMethodModal: AddPaymentMethodModal,
    editPaymentMethodModal: EditPaymentMethodModal,
    personModal: PersonModal,
    manualPaymentModal: ManualPaymentModal,
    processingPaymentModal: ProcessingPaymentModal,
    uploadDocumentsModal: UploadDocumentsModal,
    linkOpenBankingModal: LinkOpenBankingModal,
    onfidoVerificationModal: OnfidoVerificationModal,
    api: LendingAPI,
    form: formReducer,
    iwocapayDashboard: IwocapayDashboard,
    CBILSDashboard: CBILSDashboard,
    multiLoanDashboard: MultiLoanDashboard,
    navigation: Navigation,
    applyFlexiLoanView: ApplyFlexiLoanView,
    RLSDashboard: RLSDashboard,
    revenueBasedLoanDashboard: RevenueBasedLoan,
    loanBuilder: LoanBuilderReducer
});

// eslint-disable-next-line import/no-default-export
export default RootReducer;
